import { endpoints } from '@/api/endpoints';
import { useApi } from '@/api/useApi';
import { LoadingState } from '@/components/EmptyState';
import { ErrorBanner } from '@/components/ErrorBanner';
import { statusLabel } from '@/components/StatusBadge';
import { useLanguage } from '@/i18n/LanguageContext';
import { formatCurrencyMinor, formatDateTime, formatNumber } from '@/i18n/format';

/**
 * COMMERCIAL LAYER epic (ADR-075 Part C). `portalCharges` never joins
 * tariff_rule/rate (ADR-075 §Part B - tariff internals are not seller-
 * public); this renders only the snapshotted qty/rate/amount already
 * carried on `billable_event` itself, exactly what the API returns.
 */
export function ChargesTab(): JSX.Element {
  const result = useApi(() => endpoints.charges({}), []);
  const { t, locale } = useLanguage();

  if (result.status === 'loading') return <LoadingState />;
  if (result.status === 'error') return <ErrorBanner error={result.error} onRetry={result.reload} />;

  const { charges } = result.data;
  if (charges.length === 0) return <p className="sub">{t('chargesTab.noChargesYet')}</p>;

  return (
    <div className="table-scroll"><table>
      <thead>
        <tr>
          <th>{t('billing.colKind')}</th>
          <th style={{ textAlign: 'right' }}>{t('returnDetail.qty')}</th>
          <th>{t('chargesTab.unit')}</th>
          <th style={{ textAlign: 'right' }}>{t('invoicesTab.colRate')}</th>
          <th style={{ textAlign: 'right' }}>{t('billing.colAmount')}</th>
          <th>{t('dashboard.colOccurred')}</th>
        </tr>
      </thead>
      <tbody>
        {charges.map((c) => (
          <tr key={c.id} style={{ cursor: 'default' }}>
            <td>{statusLabel(t, c.kind)}</td>
            <td style={{ textAlign: 'right' }}>{formatNumber(c.qty, locale)}</td>
            <td>{c.unit}</td>
            <td style={{ textAlign: 'right' }}>{formatNumber(c.rate, locale)}</td>
            <td style={{ textAlign: 'right' }}>{formatCurrencyMinor(c.amount_minor, c.currency, locale)}</td>
            <td>{formatDateTime(c.occurred_at, locale)}</td>
          </tr>
        ))}
      </tbody>
    </table></div>
  );
}
